/* TC - Tablero de control-  Presenta lista de Dominios*/
/* TC.ListaPFC - Lista de registros agrupados por PFC*/
/* TC.ListaPFC.Detalles - Tabla de información del PFC simple o agrupado*/

//*react- recursos
  import { useState, useEffect} from "react";
  import { Panel, PanelGroup } from "rsuite";
  
//*componentes-utiles
  import CargandoSpin from "../../../../componentes/CargandoSpin";
  import { SlidingPanel } from "@reactjscomponentrepository/frontend-components/lib/components";

//*clases 
//*imágenes

//*archivo & componentes (otros componentes enlazados)
  import ListaPFC from "./TC.ListaPFC"; 

//*api's (servicios y store)
  import dashboardServicio from "../../../../api/recursos/dashboard/dashboard.servicio"; 
  import dashboardStore    from "../../../../api/recursos/dashboard/dashboard.store"; 
 
//*store's

//*datos
  import etiquetasSSC from "../../../../datos/json/etiquetasSSC.json"
 
//*funciones

//*interface  
  interface propsTC {
    tokenStore: any;
    menuStore: any;
    quitaErrorPagina:any;
    recargaPaginaSSC:any;
    recargaPaginaSSC_Not:any;
  } 

//*componente
  export default function TC(props: propsTC){

    //*api store
      const { guardaGetSummarybyUserStore, pfcDominioStore, 
              cambiaPfcDominioStore,
              cambiaRadioFiltroStore, radioFiltroStore, radioFiltroSelStore, cambiaIndiceStore,
              generaObjErrorDashboardStore } =  
          dashboardStore((state:any) =>( { 
              guardaGetSummarybyUserStore: state.guardaGetSummarybyUserStore,
              pfcDominioStore: state.pfcDominioStore,
              cambiaPfcDominioStore: state.cambiaPfcDominioStore,
              cambiaRadioFiltroStore: state.cambiaRadioFiltroStore,
              radioFiltroStore: state.radioFiltroStore,
              radioFiltroSelStore: state.radioFiltroSelStore,
              cambiaIndiceStore: state.cambiaIndiceStore,
              generaObjErrorDashboardStore: state.generaObjErrorDashboardStore
      }));  

    //*store's

    //*datos
      var _ = require('underscore');

    //*constantes y variables
      let eti = etiquetasSSC.TC;
      let x0, x1, x1a, x2, x3 = '';

    //*useState
      const [swRecarga, setSwRecarga] = useState(false); //usado para remasterizar página padre
      const [swRecargaTC, setSwRecargaTC] = useState(false); //usado para remasterizar esta página
      const [cargandoSpin, setCargandoSpin] = useState(false);

      const [buscador, setBuscador] = useState('');
      
    //*useEffect
      useEffect(()=> { // al montar
          console.log('TC - monto')
          props.quitaErrorPagina();
          cambiaRadioFiltroStore('T');
          setBuscador('');
          //console.clear();
      },[]);

      useEffect(()=> { //Carga lista pfc del tablero de control
        setCargandoSpin(true);
        dashboardServicio.cargaGetSummarybyUser(props.tokenStore)
          .then(function(response:any){
              if (response.status==200){  //revisa si hay error
                guardaGetSummarybyUserStore(response.data).then( function(datos:any) { 
                    console.log('-----cargo pfcDominioStore:', datos);
                    cambiaIndiceStore(radioFiltroSelStore);
                })
              }
              setCargandoSpin(false);  
          })
          .catch((ex) => {
              console.log ("--catch - ex (cargaGetSummarybyUser): ", ex.response.status);
              if (ex.response.status==404) //no es error solo no tiene información
                  console.log('nota: no es error solo no tiene información')
              else
                  generaObjErrorDashboardStore(ex.response, true, '', '', 'TC-Dashboard/GetSummarybyUser','TC')
              setCargandoSpin(false);    
          })
          setSwRecarga(!swRecarga);
      },[]);

      useEffect(()=> { // uso este puente para recargar elementos del front, no uso ese useState
        //console.log('TC - rederizando...........');
        //console.log("**pfcDominioStore.", pfcDominioStore);
        setSwRecargaTC(!swRecargaTC);
      },[swRecarga]);
 
    //*funciones
      const recargaPaginaSSC = () => { props.recargaPaginaSSC() } //ejecuta la función que esta en Contenido que llama a la renderización de PaginaSSC

      const recargaPaginaSSC_Not = () => { props.recargaPaginaSSC_Not() } //ejecuta la función que esta en Contenido que llama de PaginaSSC recargar el api de notificaciones para la campana

      const recargaTC = () => {  // con esto ejecuto un useEffect, lo uso para renderizar el front 
            setSwRecarga(!swRecarga);
      }

      const abreCierraDominio = (pfcIdD:any) => {  // abre y cierra el div de la propuesta
        cambiaPfcDominioStore(pfcIdD, null, null,'abreCierraDominio');
        setSwRecarga(!swRecarga)
      }

      const cambiaRadioFiltro = (opc:any) => {
        cambiaPfcDominioStore(null, null, null,'abreCierraPFCTodos');
        limpiarInputBuscador();
        let opcion = opc.target.value;
        cambiaRadioFiltroStore(opcion);
        cambiaIndiceStore(opcion);
        setSwRecarga(!swRecarga)
      };
    
      /* función que iba recontando lo seleccionado perooo se cambio para que entrará con enter */
      /* const actualizaInputBuscador = (event:any) => {     
        let valorInputBuscador= document.getElementById("inputBuscador") as HTMLInputElement | null;    
        let valorInputBuscador1:any = valorInputBuscador?.value.toString();    
        setBuscador(valorInputBuscador1); //valor del input al ir escribiendo
      } */
      const actualizaInputBuscador = (event: any) => {
        let valorInputBuscador = document.getElementById("inputBuscador") as HTMLInputElement | null;
        if (event.key === "Enter") {
          //console.log("enter....");
          let valorInputBuscador1: any = valorInputBuscador?.value.toString();
          setBuscador(valorInputBuscador1); //valor del input al ir escribiendo
          cargaBusqueda(valorInputBuscador1);
        }
      }

      const limpiarInputBuscador = () => {  
        //alert('limpiarInputBuscador');
        var espejo:any = document.getElementById("inputBuscador") as HTMLInputElement | null; 
        if (espejo)  espejo.value= "";  
        setBuscador('');
      }
      //Buscador
      const [swBusqueda, setSwBusqueda] = useState(false);
      const cargaBusqueda = (busca:any) => { 
            //alert(busca);   
            setSwBusqueda(false);
            const value = busca;
            let filtered = []
            if (value !='') {
                pfcDominioStore.map((pfcD:any, indexpfcD:any) => {
                  filtered= pfcD.pfcAgrupado.filter((filtro:any) => filtro.pfcNombre.toLowerCase().includes(value.toLowerCase()));  
                  pfcD.pfcAgrupadoBusqueda = filtered;
                  if (filtered.length > 0) { setSwBusqueda(true) }
                }); 
            }
            else { 
              pfcDominioStore.map((pfcD:any, indexpfcD:any) => { pfcD.pfcAgrupadoBusqueda = pfcD.pfcAgrupado }); 
            }
            console.log('cargaBusqueda:', pfcDominioStore);
      };


    //*vista
      return(
       <>
       {/* <p>buscador ... {buscador }</p> */}
        
        {/* nota de mensaje de error */}
          { (props.menuStore[4].errorPagina==true) &&
              (<> <label className='color-red'>Nota: se detecto un error al leer un recurso API, ¡algunos componentes pueden no funcionar correctamente!</label><br/><br/> </>)
          }
  
        {/* buscador y filtro*/}
          <div className="row mb-4">
            <div className="container-fluid">
              <div className="row">

                {/* buscador por: */}
                <div className="col-md-4" >
                  <div className = "buscar">
                                                      {/* onChange={actualizaInputBuscador} */}
                    <input id="inputBuscador" type="text" onKeyDown={actualizaInputBuscador} placeholder="Buscar por Acrónimo o Frecuencia o Ciclo" className="form-control form-control-dark" /> 
                  </div>
                  <div><a type="button"  className="searchX cursorHand zIndex-1" onClick={limpiarInputBuscador}>x</a></div>
                </div>

                {/* filtro */}
                <div className="col-md-8 derecha"  >               
                  <span className="mdi mdi-filter-variant color-azul5 spanRadio"></span>
                  <span className="spanRadio"> Filtro </span> 
                  { radioFiltroStore?.map((rd:any, indexRD:any) => ( 
                    (<>
                      <span className="spanRadio"> 
                          <input 
                              type="radio"
                              id="filtro"
                              onClick={ cambiaRadioFiltro } 
                              value={rd.id}
                              checked={rd.activo} 
                          />
                      </span>
                      <span className= "h6 spanRadio" > {rd.texto} </span> 
                    </>)
                  ))}
                </div>

              </div>
            </div>
          </div>

        {/*presentamos lista (filtro de busqueda en su caso o pfc agrupados (ambos agrupadas por dominio) */}
        {/* Tenemos 2 listas:
            pfcDominioStore.pfcAgrupadoBusqueda: trae los registros filtrados según la busqueda. Se presenta si props.buscador != ''
            pfcDominioStore: trae los registros completos paginados de 10 en 10. Se presenta si props.buscador == ''
        */}
        { buscador != ''   
          ? (<> {/* si ho hay elementos presentamos mensaje si hay de menos uno mostramos lista filtrada */}
                { swBusqueda == false
                  ? (<> <br/><p className=' color-azul4'>No hay elementos para el filtro seleccionado</p> </>)
                  : (<>
                        {pfcDominioStore?.map((pfcD:any, index:any) => (
                            (x2 = <div id={`divpanelDominio_${pfcD.id}`}>
                                    <span id="panelDes"> <span className='h3 color-azul2'> {pfcD.dominio} </span> </span>
                                  </div>),
                            (<>
                              {pfcD.pfcAgrupadoBusqueda.length > 0 &&
                                (<>
                                  <PanelGroup accordion  >
                                    { radioFiltroSelStore == 'T' &&
                                      (<>
                                          <hr/>
                                          <Panel
                                            header={x2}
                                            /* eventKey={index} usado cuando se quiere un solo panel abierto */
                                            key={pfcD.key}
                                            id={pfcD.id}
                                            collapsible={pfcD.abierto}
                                            onClick={() => abreCierraDominio(pfcD.id)}
                                          >
                                          </Panel>
                                      </>)
                                    }
                                    { (radioFiltroSelStore == 'E' )  &&
                                      (<>
                                          {pfcD.e > 0  &&
                                            (<>
                                                <hr/>
                                                <Panel
                                                  header={x2}
                                                  key={pfcD.key}
                                                  id={pfcD.id}
                                                  collapsible={pfcD.abierto}
                                                  onClick={() => abreCierraDominio(pfcD.id)}
                                                >
                                                </Panel>
                                            </>) 
                                          }  
                                      </>)
                                    }
                                    { (radioFiltroSelStore == 'C') &&
                                      (<>
                                          {pfcD.c > 0 &&
                                            (<>  
                                                <hr/>
                                                <Panel
                                                  header={x2}
                                                  key={pfcD.key}
                                                  id={pfcD.id}
                                                  collapsible={pfcD.abierto}
                                                  onClick={() => abreCierraDominio(pfcD.id)}
                                                >
                                                </Panel>
                                            </>) 
                                          } 
                                      </>)
                                    }
                                    {pfcD.abierto && (
                                      <ListaPFC
                                          key={pfcD.id}
                                          tokenStore={props.tokenStore}
                                          pfcDId = {pfcD.id}
                                          pfcDDominio = {pfcD.dominio}
                                          pfcArreglo={pfcD.arreglo} 
                                          pfcAgrupado={pfcD.pfcAgrupado} 
                                          buscador = {buscador}
                                          radioFiltroSelStore = {radioFiltroSelStore}
                                          contaE = {pfcD.e}
                                          contaC = {pfcD.c}
                                          recargaTC = {recargaTC}
                                          recargaPaginaSSC = {recargaPaginaSSC}
                                          recargaPaginaSSC_Not  = {recargaPaginaSSC_Not}
                                      />  
                                    )}  
                                  </PanelGroup> 
                                </>)
                              } 
                            </>)
                          ))} 
                    </>)
                }
            </>)
          : (<> {/* presentamos lista normal sin filtros */}
                { pfcDominioStore?.map((pfcD:any, index:any) => (
                  (x2 = <div id={`divpanelDominio_${pfcD.id}`}>
                          <span id="panelDes"> <span className='h3 color-azul2'> {pfcD.dominio} </span> </span>
                        </div>),
                  (<>
                      <PanelGroup accordion  >
                        { radioFiltroSelStore == 'T' &&
                          (<>
                              <hr/>
                              <Panel
                                header={x2}
                                /* eventKey={index} usado cuando se quiere un solo panel abierto */
                                key={pfcD.key}
                                id={pfcD.id}
                                collapsible={pfcD.abierto}
                                onClick={() => abreCierraDominio(pfcD.id)}
                              >
                              </Panel>
                          </>)
                        }
                        { (radioFiltroSelStore == 'E' )  &&
                          (<>
                              {pfcD.e > 0  &&
                                (<>
                                  <hr/>
                                  <Panel
                                    header={x2}
                                    key={pfcD.key}
                                    id={pfcD.id}
                                    collapsible={pfcD.abierto}
                                    onClick={() => abreCierraDominio(pfcD.id)}
                                  >
                                  </Panel>
                                </>) 
                              }  
                          </>)
                        }
                        { (radioFiltroSelStore == 'C') &&
                          (<>
                              {pfcD.c > 0 &&
                                  (<>  
                                      <hr/>
                                      <Panel
                                        header={x2}
                                        key={pfcD.key}
                                        id={pfcD.id}
                                        collapsible={pfcD.abierto}
                                        onClick={() => abreCierraDominio(pfcD.id)}
                                      >
                                      </Panel>
                                  </>) 
                              } 
                          </>)
                        }
                        {pfcD.abierto && (
                          <ListaPFC
                              key={pfcD.id}
                              tokenStore={props.tokenStore}
                              pfcDId = {pfcD.id}
                              pfcDDominio = {pfcD.dominio}
                              pfcArreglo={pfcD.arreglo} 
                              pfcAgrupado={pfcD.pfcAgrupado} 
                              buscador = {buscador}
                              radioFiltroSelStore = {radioFiltroSelStore}
                              contaE = {pfcD.e}
                              contaC = {pfcD.c}
                              recargaTC = {recargaTC}
                              recargaPaginaSSC = {recargaPaginaSSC}
                              recargaPaginaSSC_Not  = {recargaPaginaSSC_Not}
                          />  
                        )}  
                      </PanelGroup> 
                  </>)
                ))}  
            </>)
        }   

       
        {/* ventana de carga con spin que se abre mientras lee el api */}
           { cargandoSpin && <CargandoSpin /> }

    </>
    )
  }
